<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">
        Cargar mi tarjeta
      </b-card-header>
      <b-card-body v-if="!model.viewResult">
        <label>Importe</label>
        <vue-numeric
          currency="$"
          v-bind:precision="2"
          decimal-separator="."
          thousand-separator=" "
          v-model="model.importe"
          class="form-control"
          @blur="validateAmount"
        ></vue-numeric>
        <label v-if="!model.hideCredit" class="col-md-12 text-center"
          >De {{ model.formattedCredit }} disponible</label
        >
        <div>
          <div class="row text-left" style="margin-top: 10px">
            <div class="col-md-6">
              <b-button class="btn btn-lg btn-danger" @click="goBack"
                >Volver</b-button
              >
            </div>
            <div class="col-md-6 text-right">
              <save-button text="Recargar" @click="rechargeCard"></save-button>
            </div>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="model.viewResult">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultado.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px;">
                <i :class="resultado.Icono"></i>
              </span><br>
              <span class="alert-inner--text" v-html="resultado.Texto"></span>
            </base-alert>
          </div>          
          <div class="col-md-12" id="btnVolver">
            <div class="row text-center" style="margin-top: 10px">
              <div class="col-md-12">
                <b-button class="btn btn-lg btn-danger" v-if="!AccountCloseToPercentage" @click="goBack"
                  >Volver</b-button
                >
                <b-button class="btn btn-lg btn-danger" v-if="AccountCloseToPercentage" @click="goUrl"
                  >Continuar</b-button
                >
              </div>
            </div>
          </div>          
        </div>
      </b-card-body>
    </b-card>
    <contact-help-desk ref="contact-help-desk" titleModal="Solicitud Rechazada" />
    <modal-with-link ref="modal-with-link" />
  </div>
</template>


<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import generalHelpers from "@/helpers/generalHelpers";
import ContactHelpDesk from "@/views/ContactHelpDesk";
import ModalWithLink from "@/components/ModalWithLink.vue";

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  components: {
    "modal-with-link": ModalWithLink,
    "contact-help-desk": ContactHelpDesk
  },
  data() {
    return {
      AccountCloseToPercentage:false,
      model: {
        credit: 0,
        hideCredit: true,
        formattedCredit: "$0.0",
        importe: "",
        viewResult: false,
      },
      helpDeskInformation: {
        Message: "",
        Show: false,
        ShowInfo: false,
        WhatsappUrl: "",
        PhoneNumber: "",
        EmailAddress: "",
        EmailSubject: "",
        MessageBody: "",
        ShowUnlockMail: false,
        Name: "",
        ShowContactarSoporte: false
      },
      resultado: {
        Texto: "prueba",
        Tipo: "success",
        Icono: "fa fa-fw fa-thumbs-up",
      },
      estados: { Aprobado: 3, Rechazado: 4, Consulta: 5 },
    };
  },
  methods: {
    filtrar() {
      let context = this;
      var req = {};
      axiosHelpers.axiosGet("Account/GetCredit", req, this, function (data) {
        context.model.credit = data.ResponseVM.Credit;
        context.model.hideCredit = data.ResponseVM.HideCredit;
        context.model.formattedCredit = data.ResponseVM.FormattedCredit;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    goUrl() {
      this.$router.push("verificacionidentidad");
    },
    rechargeCard() {
      let context = this;

      if (!context.validateAmount()) {
        return;
      }

      var req = {
        DeviceID: "",
        IsAndroid: false,
        Amount: context.model.importe,
      };

      axiosHelpers.axiosPost(
        "Mastercard/ChargeCardBalance",
        req,
        this,
        function (data) {
          context.model.viewResult = true;
          var msg = "prueba";
          if (data.Alerts == null || data.Alerts.length == 0) {
            if (
              data.ResponseVM.ConsultarRecarga.TransactionStateID ==
              context.estados.Aprobado
            ) {
                if(data.ResponseVM.AccountCloseToPercentage){
                  msg = "La recarga se realizó satisfactoriamente" +
                  "<br/>" +data.ResponseVM.Messagge;
                  context.AccountCloseToPercentage = data.ResponseVM.AccountCloseToPercentage;
                }
                else{                
                  msg =
                  "La recarga se realizó satisfactoriamente" +
                  "<br/>" +
                  " Número de operación: " +
                  data.ResponseVM.ConsultarRecarga.QueueID +
                  "<br/>" +
                  " Número de comprobante: " +
                  data.ResponseVM.ConsultarRecarga.FormatedReceiptID +
                  "<br/>" +
                  " Número de transacción: " +
                  data.ResponseVM.ConsultarRecarga.TransactionNumber +
                  "<br/>" +
                  " Importe: $" +
                  context.model.importe +
                  "<br/>" +
                  " Fecha: " +
                  data.ResponseVM.ConsultarRecarga.FormattedTransactionDatetime +
                  "<br/>";                
                }

                context.resultado = {
                    Texto: msg,
                    Tipo: "success",
                    Icono: "fa fa-fw fa-thumbs-up",
                };
              
            } else if (
              data.ResponseVM.ConsultarRecarga.TransactionStateID ==
                context.estados.Rechazado ||
              data.ResponseVM.ConsultarRecarga.TransactionStateID ==
                context.estados.Consulta
            ) {
              context.resultado = {
                Texto: data.ResponseVM.ConsultarRecarga.ErrorMsg,
                Tipo: "danger",
                Icono: "fa fa-fw fa-thumbs-down",
              };
            } else if(data.ResponseVM.LimitReached) {
              msg = "No se pudo finalizar la operación" +
                  "<br/>" + data.ResponseVM.Messagge;
                  context.AccountCloseToPercentage = data.ResponseVM.LimitReached;
              context.resultado = {
                Texto:
                  msg,
                Tipo: "warning",
                Icono: "fa fa-fw fa-thumbs-down",
              };
            } else {
              context.resultado = {
                Texto:
                  "La operación esta demorando mas de lo normal, te avisaremos cuando este el resultado final de la operación",
                Tipo: "warning",
                Icono: "fa fa-fw fa-clock",
              };
            }
          } else {
            context.resultado = {
              Texto: data.Alerts[0].Message,
              Tipo: "danger",
              Icono: "fa fa-fw fa-thumbs-down",
            };
          }
        },
        function(message) {
          context.$refs["modal-with-link"].showModalWithParams(
            "Solicitud Rechazada",
            message,
            "verificacionidentidad",
            "Continuar"
          );
        },
        function() {
          context.model.viewResult = false;
          context.helpDeskInformation.Show = true;
          context.helpDeskInformation.ShowContactarSoporte = true;
          context.helpDeskInformation.Message = 
          'Superaste tu límite de operación, comunicate con nosotros para validar el nivel de tu cuenta.';
          context.helpDeskInformation.EmailAddress =
            context.$store.getters.EmailAddress;
          context.helpDeskInformation.EmailSubject =
            context.$store.getters.EmailSubject;
          context.helpDeskInformation.MessageBody =
            context.$store.getters.MessageBody;
          context.helpDeskInformation.UrlWhatsapp =
            context.$store.getters.UrlWhatsapp;
          context.helpDeskInformation.PhoneNumber =
            context.$store.getters.PhoneNumber;
          context.$refs["contact-help-desk"].setHelpDeskInformation(
            context.helpDeskInformation
          );
        }
      );
    },
    validateAmount() {
      let context = this;
      if (context.model.importe <= context.model.credit) {
        return true;
      } else {
        notificationHelpers.showError(
          "Error",
          "El importe es mayor que su saldo",
          context
        );
        return false;
      }
    },
  },
  beforeMount: function () {
    let context = this;

    context.filtrar();
  },
  mounted: function () {},
  watch: {},
};
</script>